import { useState } from "react";
import classNames from "classnames";

import { translate } from "@ascendnow/shared";

import styles from "./AscSearchBar.module.scss";
import AscButton from "../AscButton/AscButton";
import AscSearchInput from "../AscInputFields/AscSearchInput/AscSearchInput";

export type AscSearchBarProps = {
  handleSearchBar: (value: string) => void;
  placeholder?: string;
  initialValue?: string;
  className?: string;
  inputClassName?: string;
};

export default function AscSearchBar({
  handleSearchBar,
  initialValue,
  placeholder = translate("searchByName"),
  className,
  inputClassName,
}: AscSearchBarProps) {
  const [inputValue, setInputValue] = useState<string>(initialValue || "");
  return (
    <div
      data-testid="asc-search-bar"
      className={classNames(styles.ground, className)}
    >
      <AscSearchInput
        value={inputValue || initialValue}
        placeholder={placeholder + "..."}
        onChange={(event) => {
          if (event.target.value === "") {
            handleSearchBar("");
          }
          setInputValue(event.target.value);
        }}
        className={classNames(styles.input, inputClassName)}
        size="medium"
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleSearchBar(inputValue);
          }
        }}
      />
      <AscButton
        className={styles.button}
        onClick={() => handleSearchBar(inputValue)}
      >
        {translate("search")}
      </AscButton>
    </div>
  );
}
